import { useQuery } from '@tanstack/react-query';

import { workspaceQuery } from '@/shared/api/queries/workspace';

import { continueAtFor } from './continue-at';
import { useStudioResume } from './use-studio-resume';

import type { StudioItem, StudioModel } from './use-studio';

/**
 * The Overview follows the latest visit, with a workspace fallback for existing accounts.
 * Reads the shared workspace cache without the Workshop page's polling.
 */
export function useContinueAt(studio: StudioModel | undefined): StudioItem | null {
  const workspace = useQuery({ ...workspaceQuery, refetchInterval: false });
  const { visit } = useStudioResume();
  return studio
    ? continueAtFor(
        studio,
        workspace.data,
        visit?.programSlug === studio.programSlug ? visit : null,
      )
    : null;
}
